export { OrderDetailTemplate } from './OrderDetailTemplate';
export type {
  OrderDetailItem,
  OrderDetailItemField,
  OrderDetailItemPolicyHint,
  OrderDetailSummaryField,
  OrderDetailTemplateLabels,
  OrderDetailTemplateProps,
} from './OrderDetailTemplate.types';
